import { isPlanned, hasEditionRoot, findViewInfoForAction, deduceViewDefinitionName } from 'utilities/view';

module.exports = {
  isPlanned,
  hasEditionRoot,
  findViewInfoForAction,
  deduceViewDefinitionName
};